import { BackendHttpService } from '../../../services/backendHttpService';

export interface PositionProfileListItem {
    id: number;
    shortCode: string;
    name: string;
    description: string | null;
    isActive: boolean;
}

export interface PositionProfileTechnologyCanonical {
    technologyCanonicalId: number;
    canonicalName: string;
    requiredLevel: number | null;
}

export interface PositionProfileWithTechnologies extends PositionProfileListItem {
    technologyCanonicals: PositionProfileTechnologyCanonical[];
}

class PositionProfilesService extends BackendHttpService {
    constructor() {
        super('api/position-profiles');
    }

    protected override buildUrl(path: string = ""): string {
        // Query strings must not have a slash inserted before them
        if (path.startsWith('?')) {
            return `${this.apiUrl}${path}`;
        }
        return super.buildUrl(path);
    }

    async getAll(): Promise<PositionProfileListItem[]> {
        return this.get<PositionProfileListItem[]>('');
    }

    async getWithTechnologies(): Promise<PositionProfileWithTechnologies[]> {
        return this.get<PositionProfileWithTechnologies[]>('?includeTechnologies=true');
    }
}

const _service = new PositionProfilesService();

export const positionProfilesService = {
    getAll: () => _service.getAll(),
    getWithTechnologies: () => _service.getWithTechnologies(),
};

